import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { debounceTime } from 'rxjs/operators';
import { RealstateService } from '../services/realstate.service';
import { SnackBarService } from '../services/snack-bar.service';
import { ConfirmationModalComponent } from '../shared/confirmation-modal/confirmation-modal.component';

@Component({
  selector: 'app-real-estate-closed-list',
  templateUrl: './real-estate-closed-list.component.html',
  styleUrls: ['./real-estate-closed-list.component.css']
})
export class RealEstateClosedListComponent implements OnInit {

  statusColumn: any[] = [
    { value: '', viewValue: 'All' },
    { value: 'in_progress', viewValue: 'In Progress' },
    { value: 'pending', viewValue: 'Pending' },
    { value: 'completed', viewValue: 'Completed' },
  ];
  realEstateClosedForm: FormGroup;
  pageEvent: PageEvent;
  isLoading = false;

  displayedColumns: string[] = [
    'name',
    'phone',
    'ReferralSource',
    'area',
    'notes',
    'MyCommission',
    'closingDate',
    'update',
    'Status',
    'Action',
  ];

  paginationCountData: any;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  dataSource: any = null;
  constructor(
    private realstateService: RealstateService,
    public dialog: MatDialog,
    private snackBarService: SnackBarService,
    private route: Router,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.realEstateClosedFormBuild();
    this.getClosedList();
    this.filters();
  }

  realEstateClosedFormBuild(): void {
    this.realEstateClosedForm = this.formBuilder.group({
      page: 1,
      pageLimit: 10,
      description: '',
      status: '',
      start_date: '',
      end_date: ''
    });
  }

  getClosedList(): void {
    this.isLoading = true;
    this.realstateService.getClosedRealEstateList(this.realEstateClosedForm.value).subscribe((response) => {
      this.paginationCountData = response.data;
      this.dataSource = response.data.data;
      this.isLoading = false;
    });
  }

  filters(): void {
    this.realEstateClosedForm.valueChanges.pipe(debounceTime(300)).subscribe((response) => {
      this.getClosedList();
    });
  }

  paginationHandler(event: PageEvent): void {
    this.realEstateClosedForm.get('page').setValue(event.pageIndex + 1);
    this.realEstateClosedForm.get('pageLimit').setValue(event.pageSize);
  }

  pageIndexHandler(): void {
    this.paginator.pageIndex = 0;
    this.realEstateClosedForm.get('page').setValue(1);
  }

  clearField(controller: string): void {
    this.realEstateClosedForm.get(controller).setValue('');
  }

  delete(id): void {
    this.dialog
      .open(ConfirmationModalComponent, {
        data: {
          title: 'Confirm',
          message: 'Are you Sure You want to delete this Data',
        },
      })
      .afterClosed()
      .subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.realstateService.delete(id).subscribe((response) => {
            if (response) {
              this.snackBarService.openSnackBar(
                response.message,
                'error-class'
              );
              this.realEstateClosedFormBuild();
              this.realEstateClosedForm.get('page').setValue(1);
              this.realEstateClosedForm.get('description').setValue('');
              this.realEstateClosedForm.get('status').setValue('');
              this.getClosedList();
            }
          });
        }
      });
  }

}
